<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <h3>Shared Options</h3>
      </v-flex>

      <v-flex lg12 xl5>
        <p>Options by Sender</p>
        <v-data-table
          :headers="headers"
          :items="shareOptionsData"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.count }}</td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ShareTable',
  props: ['shareOptionsData'],
  data() {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Shared',
          value: 'count'
        }
      ]
    };
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/options/ShareTable.vue